module.exports = __webpack_public_path__ + "static/media/ImageMovie.54f12567.png";